import React from 'react';
import { Download, ShieldCheck, Lock, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full px-4 py-12 md:py-20 overflow-hidden" data-id="element-112">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-113">
        {/* Copy Column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6 order-2 md:order-1" data-id="element-114">
          <div className="space-y-2" data-id="element-115">
            <span className="text-xs font-bold tracking-widest text-taupe uppercase" data-id="element-116">
              Edición Digital · EpikkaStore
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif uppercase tracking-widest leading-none" data-id="element-117">
              <span className="block text-clay" data-id="element-118">Apaga tu</span>
              <span className="block text-sage mt-2" data-id="element-119">Inflamación</span>
            </h1>
          </div>

          <p className="text-lg md:text-xl text-ink/85 leading-relaxed max-w-lg" data-id="element-120">
            Si llevas años sintiéndote hinchada, cansada y desconectada de tu
            cuerpo… no estás exagerando. Tu cuerpo lleva tiempo hablándote. Esta
            es la guía de 21 días que finalmente lo escucha.
          </p>

          <ul className="space-y-3 text-ink/90" data-id="element-121">
            {['Entiende por qué tu cuerpo se inflama (sin tecnicismos médicos)', 'Plan práctico de 21 días, paso a paso', 'Menús semanales completos y listas de compra', '15 recetas antiinflamatorias rápidas', 'Enfoque integral: cuerpo, hormonas, descanso y emociones'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-122">
                <CheckCircle2 className="w-5 h-5 text-clay shrink-0 mt-0.5" data-id="element-123" />
                <span data-id="element-124">{bullet}</span>
              </li>)}
          </ul>

          <div className="pt-4 space-y-5" data-id="element-125">
            <div className="flex items-end gap-4 flex-wrap" data-id="element-126">
              <span className="text-2xl text-muted line-through decoration-1" data-id="element-127">
                $39.99
              </span>
              <span className="text-5xl font-serif text-clay font-bold" data-id="element-128">
                $9.99 <span className="text-2xl" data-id="element-129">USD</span>
              </span>
              <span className="bg-sage text-ivory text-sm font-bold px-3 py-1 rounded-full mb-2" data-id="element-130">
                –75% OFF
              </span>
            </div>

            <button onClick={scrollToPricing} className="w-full md:w-auto bg-clay hover:bg-clay-dark text-ivory text-lg font-semibold py-4 px-8 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-131">
              Empezar mi camino antiinflamatorio — $9.99
            </button>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-taupe font-medium" data-id="element-132">
              <span className="flex items-center gap-1.5" data-id="element-133">
                <Download className="w-4 h-4" data-id="element-134" /> Acceso digital inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-135">
                <ShieldCheck className="w-4 h-4" data-id="element-136" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-137">
                <Lock className="w-4 h-4" data-id="element-138" /> Pago seguro
              </span>
            </div>
          </div>
        </motion.div>

        {/* Image Column */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative order-1 md:order-2 flex justify-center" data-id="element-139">
          <div className="relative w-full max-w-md aspect-[3/4] perspective-1000" data-id="element-140">
            <div className="absolute inset-0 bg-ivory rounded-full blur-3xl opacity-50 transform -translate-x-10 translate-y-10" data-id="element-141"></div>

            <img src="https://cdn.magicpatterns.com/uploads/stGjEReSB4tayGLfYyfj9V/ChatGPT_Image_20_may_2026,_11_21_25_p.m..png" alt="Portada del ebook Apaga tu Inflamación" className="relative z-10 w-full h-full object-cover rounded-r-2xl rounded-l-sm shadow-2xl transform rotate-y-[-10deg] rotate-z-[2deg] transition-transform duration-500 hover:rotate-y-0 hover:rotate-z-0" style={{
            boxShadow: '-20px 20px 30px rgba(43, 37, 32, 0.15), inset 2px 0 5px rgba(255,255,255,0.3)'
          }} data-id="element-142" />
            <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-black/20 to-transparent z-20 rounded-l-sm transform rotate-y-[-10deg] rotate-z-[2deg]" data-id="element-143"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}